import React from 'react';
import '../../css/About.css'

function TestimonialItem() {
    return (
        <div className=" d-flex justify-content-center align-items-center " style={{ height: '500px', width: '100%' }}>
            <div className="d-flex flex-column align-items-center justify-content-between cardWrapper p-4" style={{ maxWidth: '500px' }}>
                <img src={require(`../../resource/testimonial-1.jpg`)} style={{ width: '100px', height: '100px'}} className="rounded-circle testimonial-img" alt="" />
                <h3 className="white-1">Lorem</h3>
                <h5 className="white-2">ipsum dolor</h5>
                <div className="review mb-2">
                    <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                    <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                    <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                    <ion-icon name="star-half-outline" style={{ color: "#777777", fontSize: "18px" }}></ion-icon>
                    <ion-icon name="star-outline" style={{ color: "#777777", fontSize: "18px" }}></ion-icon>
                    {/* <span className='text-muted' style={{fontSize:"13px"}}> (Based on 4 review) </span> */}

                </div>
                <div className="white-3 h6">" ndis aliquid voluptates animi sint accusamus nesciunt recusandae laborum doloribus! Vero quas, deleniti obcaecati odio harum fugit numquam consectetur officia dicta sed voluptas! Blanditiis quisquam perferendis dicta cum repellendus, incidunt qui nesciunt necessitatibus culpa sunt, sint, optio placeat! "</div>
            </div>

        </div>
    )
}

export default TestimonialItem;
